import { createContext } from "react";
import type { User, Session } from "@supabase/supabase-js";
import type { Profile, Library, AccountType } from "@/types/database";

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  library: Library | null;
  isLoading: boolean;
  isAdmin: boolean;
  isLibraryOwner: boolean;
  accountType: AccountType | null;
  isOnboarded: boolean;
  isVerified: boolean;
  needsOnboarding: boolean;
  activationStage: "signed_out" | "signed_in_unverified" | "signed_in_needs_onboarding" | "ready";
  signIn: (email: string, password: string) => Promise<{ data: { user: User | null; session: Session | null }; error: Error | null }>;
  signUp: (
    email: string,
    password: string,
    meta?: { full_name: string; account_type?: AccountType },
    options?: { emailRedirectTo?: string }
  ) => Promise<{ error: Error | null }>;
  signInWithGoogle: (nextPath?: string) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  signOutAllDevices: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
